import { ActionEnum } from '../../enum/action.enum';
import { IAction } from '../../interface/action/action.interface';

export function returnAction<T = any>(type: ActionEnum, payload?: T, isImmediate?: boolean): IAction<T> {
  return {
    type, payload, isImmediate
  };
}
